import { Component, OnInit } from '@angular/core';
import {PostsService} from '../common/services/posts.service';
import {PostDO} from '../common/data-objects/PostDO';
import {ToastrService} from 'ngx-toastr';
import { Meta, Title } from '@angular/platform-browser';
import { Angulartics2 } from 'angulartics2';
import { SeoService } from '../common/services/seo.service';

@Component({
  selector: 'app-blog-page',
  templateUrl: './blog-page.component.html',
  styleUrls: ['./blog-page.component.scss']
})
export class BlogPageComponent implements OnInit {
  posts: PostDO[];
  isLoading: boolean;

  constructor(
    private postsService: PostsService,
    private toastr: ToastrService,
    private titleService: Title,
    private angulartics2: Angulartics2,
    private meta: Meta,
    private seoService: SeoService
  ) {
    this.seoService.setTitle('Blog - Fun Bible');
    this.seoService.setDescription('Gândurile mele legate de FunBible');
    this.meta.updateTag({ property: 'og:url', content: 'https://funbible.net/blog/' });
    this.meta.updateTag({ property: 'og:image', content: 'https://funbible.net/assets/reviews.png' });
    const initialKeywords = ['blog despre jocuri biblice', 'postari despre subiecte crestine', 'postari despre jocuri biblice','jocuri gratuite', 'jocuri de copii', 'jocuri ptr copii', 'jocuri online copii', 'povesti pentru copii', 'povestire biblica', 'jocuri gratis'].join();
    this.meta.updateTag({property: 'keywords', content: initialKeywords});
    this.angulartics2.eventTrack.next({
      action: 'Blog',
      properties: { category: 'pageView' },
    });
  }

  ngOnInit() {
    this.isLoading = true;
    this.postsService.getBlogPosts(15).subscribe((postsData) => {
      this.posts = postsData.posts;
      this.isLoading = false;
    }, () => {
      this.toastr.error('Acest conținut nu s-a putut încărca!');
      this.isLoading = false;
    });
  }

}
